/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ChecklistCategoryItem {
  title: string;
  subCategoryTitle: string;
  description: string;
  colour: string;
}
